<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutter">
        <back-button returnUrl="/security/0"></back-button>
      </b-row>
      <ca-form-global :mode="mode" :id="id"  :readonly="!isEditable"></ca-form-global>
    </template>
  </page-outline>
</template>
<script>

import _ from 'lodash'
import backButton from "@/components/common/backButton.vue"
import CAFormGlobal from "@/pages/security/CAFormGlobal.vue"
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'CAForm',
  components: {
    'back-button': backButton,
    'ca-form-global':CAFormGlobal,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    }
  },
  data: () => {
    return {
      formType: 'add',
      pageTitle: '',
    }
  },
  created () {
    this.formType = this.mode
    this.pageTitle = this.$i18n.t('common.security.' + this.mode + '_ca')
  },
  methods: {
  }
}

</script>
